import React, { useContext, useEffect } from "react";

import { Button, Col, Container, Form, Modal, Row } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { ErrorMessage } from "@hookform/error-message";
import { errorMessage } from "utils/utilities";
import { AutoGrowTextarea } from "components/AutoGrowTextarea";
import * as claimsApi from "@api/claimsApi";
import NotyfContext from "contexts/NotyfContext";

export const AddRemarkModal = ({
    modalInfo,
    setModalInfo,
    view,
    rerender,
    setRerender,
}) => {
    const notyf = useContext(NotyfContext);

    //
    // States
    //

    const schema = yup.object().shape({
        remarks: yup.string().required("This field is required"),
    });

    const {
        control,
        formState: { errors },
        handleSubmit,
        reset,
    } = useForm({
        resolver: yupResolver(schema),
    });

    //
    // Functions
    //

    const closeModal = () => {
        setModalInfo({ open: false });
    };

    const updateInProgress = async (data) => {
        try {
            const response = await claimsApi.updateInProgress(
                modalInfo.id,
                data
            );

            if (response.status === 200) {
                notyf.open({
                    type: "success",
                    message:
                        "Successfully updated status of Invoice to in-progress.",
                });
                setRerender(!rerender);
                closeModal();
            }
        } catch (error) {
            notyf.open({
                type: "danger",
                message: error,
            });
        }
    };

    useEffect(() => {
        reset({
            remarks: modalInfo.remarks,
        });
    }, [reset, modalInfo]);

    return (
        <Modal
            show={modalInfo.open}
            onHide={() => setModalInfo({ open: false, action: "add" })}
            size="md"
            centered
        >
            <Modal.Header closeButton>
                Update Invoice to in progress
            </Modal.Header>
            <Modal.Body className="m-1">
                <Container fluid className="p-0">
                    <Row>
                        <Col md={12}>
                            <Form.Group className="mb-3">
                                <Form.Label
                                    htmlFor="description"
                                    className="font-weight-bold"
                                >
                                    Remarks
                                </Form.Label>
                                <Controller
                                    control={control}
                                    defaultValue=""
                                    name="remarks"
                                    render={({
                                        field: { value, onChange, onBlur },
                                    }) => (
                                        <>
                                            {view ? (
                                                <p>
                                                    {value || "No note added"}
                                                </p>
                                            ) : (
                                                <AutoGrowTextarea
                                                    key={modalInfo.id}
                                                    onBlur={onBlur}
                                                    onChange={onChange}
                                                    fieldValue={value}
                                                    errors={errors.remarks}
                                                />
                                            )}
                                        </>
                                    )}
                                />
                                <ErrorMessage
                                    errors={errors}
                                    name="remarks"
                                    render={({ message }) =>
                                        errorMessage(message)
                                    }
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Container>
            </Modal.Body>
            <Modal.Footer>
                <Row>
                    <Col md={12} className="text-center">
                        {!view && (
                            <Button
                                variant="primary"
                                type="submit"
                                onClick={handleSubmit(updateInProgress)}
                            >
                                Submit
                            </Button>
                        )}
                        <Button variant="link" onClick={() => closeModal()}>
                            Cancel
                        </Button>
                    </Col>
                </Row>
            </Modal.Footer>
        </Modal>
    );
};
